module.exports = __webpack_public_path__ + "img/travel-agency__website.b79dcb0a.jpg";